import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute, Params } from '@angular/router';
import { trackById, trackByIndex } from '@core/utils/utils';
import { Job } from '@models/job/job';
import { Application } from '@models/profile/application';
import { Bookmark } from '@models/profile/bookmark';
import { JobSearchContextEnum } from '@models/search/job-search-context.enum';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select } from '@ngxs/store';
import { ApplicationStoreService } from '@store/profile/application-store.service';
import { BookmarkToggle } from '@store/profile/bookmark/bookmark.actions';
import { BookmarkState } from '@store/profile/bookmark/bookmark.state';
import { JobSearchLoadMore } from '@store/search/job-search/job-search.actions';
import { JobSearchState } from '@store/search/job-search/job-search.state';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';

@Component({
  selector: 'company-partners-jobs',
  templateUrl: './partners-jobs.component.html',
  styleUrls: ['./partners-jobs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PartnersJobsComponent {
  @Select(JobSearchState.result(JobSearchContextEnum.Partner, 'hits')) jobs$: Observable<Job[]>;
  @Select(JobSearchState.result(JobSearchContextEnum.Partner, 'nbHits')) total$: Observable<number>;
  @Select(JobSearchState.result(JobSearchContextEnum.Partner, 'page')) page$: Observable<number>;
  @Select(JobSearchState.result(JobSearchContextEnum.Partner, 'nbPages')) nbPages$: Observable<number>;
  @Select(JobSearchState.loading(JobSearchContextEnum.Partner)) loading$: Observable<boolean>;
  @Select(BookmarkState) bookmarkMap$: Observable<Map<string, Bookmark>>;

  applications$: Observable<Map<string, Application>>;
  queryParams$: Observable<Params>;
  trackById = trackById;
  trackByIndex = trackByIndex;

  constructor(applicationStoreService: ApplicationStoreService, route: ActivatedRoute) {
    this.applications$ = applicationStoreService.applications$;
    this.queryParams$ = route.paramMap.pipe(
      map((paramMap) => paramMap.get('companyId')),
      map((companyId) => ({ [JobSearchContextEnum.Partner]: companyId })),
      shareReplay()
    );
  }

  @Dispatch() toggleBookmark = (job: Job): BookmarkToggle => new BookmarkToggle(job.id);
  @Dispatch() loadMore = (): JobSearchLoadMore => new JobSearchLoadMore(JobSearchContextEnum.Partner);
}
